import { Link } from 'gatsby';
import React from 'react';
import ArrowDownIcon from '../images/icons/arrow-down.svg';
import { buildImageObj, imageUrlFor } from './sanity/image-url';

function BrandTeaser(props) {
  return (
    <div className="asset-tile">
      <figure className="asset-tile__media">
        {props.image && props.image.asset && (
          <img
            src={imageUrlFor(buildImageObj(props.image))
              .width(500)
              .height(280)
            }
          />
        )}
      </figure>
      <div className="asset-tile__title">
        {props.file && (
          <a href={props.file.asset.url}>
            <div className="icon-outline icon-outline--black icon-outline--sm">
              <ArrowDownIcon style={{ fill: '#000000' }} />
            </div>
          </a>
        )}
        {props.assetName}&nbsp;
        <span>
          {props.tags.map(tag => (
            <>{tag}, </>
          ))}
        </span>
      </div>
    </div>
  );
}

export default BrandTeaser;
